export enum ChargebeePortalSection {
    PAYMENT_SOURCES = 'PAYMENT_SOURCES',
    BILLING_HISTORY = 'BILLING_HISTORY',
    ADDRESS = 'ADDRESS',
}
